import { render } from "./component-adress-copy.vue?vue&type=template&id=bc4ffd4c"
import script from "./component-adress-copy.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-copy.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/field-wrappers/component-adress-copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc4ffd4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc4ffd4c', __exports__)) {
    api.reload('bc4ffd4c', __exports__)
  }
  
  module.hot.accept("./component-adress-copy.vue?vue&type=template&id=bc4ffd4c", () => {
    api.rerender('bc4ffd4c', render)
  })

}


export default __exports__